import store from '@/store'
import { ref, Ref, watch } from 'vue'

export const useGlobal = <T, R>(api: (...rest: T[]) => Promise<R>) => {
  return async (...rest: T[]): Promise<R> => {
    store.commit('status/loading', true)
    const res = await api(...rest)
    store.commit('status/loading', false)
    return res
  }
}

export const useRequest = <T, R>(
  api: (...rest: R[]) => Promise<T>,
  options?: {
    onSuccess?: (res: T, ...rest: R[]) => void;
    onError?: (error: Error, ...rest:R[]) => void;
  }
): [Ref, (...rest: R[]) => Promise<T | null>] => {
  const { onSuccess, onError } = options || {}

  const loading = ref(false)
  const wrap = async (...rest: R[]): Promise<T | null> => {
    loading.value = true
    let res: T | null = null
    try {
      res = await api(...rest)
      if (typeof onSuccess !== 'undefined') {
        onSuccess(res, ...rest)
      }
    } catch (error) {
      if (typeof onError !== 'undefined') {
        onError(error as Error, ...rest)
      } else {
        throw error
      }
    } finally {
      loading.value = false
    }
    return res
  }
  return [loading, wrap]
}

export const slideIn = (
  val: Ref,
  fn = (val: number, old: number): boolean => val > old
): [Ref, Ref] => {
  const anims = [
    ['slideInLeft', 'slideOutRight'], // back
    ['slideInRight', 'slideOutLeft'] // go
  ]
  const [enter, leave] = [ref(''), ref('')]
  watch(val, (val, old) => {
    const i = fn(val, old) ? 1 : 0
    const res = anims[i].map((v) => 'animated fast ' + v)
    enter.value = res[0]
    leave.value = res[1]
  })
  return [enter, leave]
}
